// eslint-disable-next-line import/prefer-default-export
export const pageTypeList = {
    DETAIL: {
        value: 'detail',
    },
    CREATE: {
        value: 'create',
    },
    BASIC_INFO: {
        value: 'basic-info',
    },
};
